import * as _ from 'underscore';
import {
  RegulationFilterModel,
  RegulationModel,
  LinkedRule,
  TableSortModel,
  LinkedPolicy,
} from '../../core/models/regulation';
import {
  FilterViewModel,
  MasterFilterModel,
} from '../../core/models/regulation';
import { FormControl } from '@angular/forms';
import { UserProfile } from '../../core/models/user';

import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { HttpErrorResponse } from '@angular/common/http';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import { GDPRService } from 'src/app/core/services/rulebook';
import { Logger, MasterHelper } from 'src/app/core/utilities';
import { Role } from 'src/app/core/models/user-management/role';
import {
  AlertDialogModel,
  ToastViewModel,
} from 'src/app/core/models/view-model';
import { Policies } from 'src/app/core/models/rulebook/policies';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { RegulationService } from '../../core/services/regulation';
import { AuthService } from '../../core/services/auth/auth.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { KeywordItem } from './../../core/models/rulebook/keyword-item';
import { ItemInfoDto } from 'src/app/core/models/rulebook/item.info-dto';
import { SessionService } from '../../core/services/auth/session.service';
import { KeywordModal } from 'src/app/core/models/rulebook/keyword-modal';
import { CommonService } from './../../core/services/common/common.service';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationDetail } from './../../core/models/regulation/regulation-detail';
import { CompareItemModel } from './../../core/models/filter-model/compare-item-model';
import { SiblingRulebookModel } from './../../core/models/rulebook/sibling-rulebook-model';
import { RegulationDetailModel } from 'src/app/core/models/regulation/regulation-detail-model';
import {
  KeywordDataList,
  ModalAnalysisData,
} from 'src/app/core/models/rulebook/keyword-item';
import {
  Component,
  Renderer2,
  OnInit,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef,
  Inject,
  AfterViewInit,
  HostListener,
  ViewEncapsulation,
  ChangeDetectorRef
} from '@angular/core';
import { UserManagementService } from './../../core/services/user-management/user-management.service';
import {
  RuleAnalytic,
  RuleAnalyticData,
} from 'src/app/core/models/rulebook/rule-analytic-data-model';
import {
  RegulationDataModel,
  RegulationFilterViewModel,
} from 'src/app/core/models/regulation/regulation.model';
import { JurisdictionDialogComponent } from '../distributed-ui-components/jurisdiction-dialog/jurisdiction-dialog.component';
import { ChangeViewerDialogComponent } from '../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { RulebookSummaryComponent } from '../shared/rulebook-summary/rulebook-summary.component';
import {
  RulebookModel,
  setSummaryDetails,
} from 'src/app/core/models/rulebook/rulebook.model';
import { RulebookSummary } from 'src/app/core/models/rulebook/rulebook-summary';
import { promise } from 'protractor';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { RulesConnectionComponent } from '../library/rules-connection/rules-connection.component';
import {
  LinkedAppliesAcrossModel,
  LinkedConnectionModel,
  OwnerCommentModel,
} from 'src/app/core/models/rulebook/linked-connection-model';
import {
  LinkedAppliesAcrossIdModel,
  LinkedConnectionIdModel,
} from 'src/app/core/models/regulation/linked-connectionId-model';
import { LinkedAppliedAcrossModel } from 'src/app/core/models/rulebook/linked-applied-across-model';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Controls } from 'src/app/core/models/rulebook/controls';
import { LinkedControlData } from 'src/app/core/models/rulebook/linked-control-data-model';
import { DeleteDialogComponent } from '../distributed-ui-components';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { ModalDialogComponent } from '../distributed-ui-components/modal-dialog/modal-dialog.component';
import { ControlDocument } from 'src/app/core/models/rulebook/control-document';
import { table } from 'console';
import { FilterViewModelForOwner } from 'src/app/core/models/regulation/filter-view.model';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { reverse } from 'lodash';
import { AngularEditorConfig } from '@kolkov/angular-editor';
// import * as customBuild from './../../../ckCustomeBuild/build/ckeditor';
import { RuleVersionFilterViewModel, VersionRegulationModel } from 'src/app/core/models/regulation/version-history-model';
import { RulebookVersionDialogComponent } from '../rulebook-version-dialog/rulebook-version-dialog.component';
import { RulebookFilterModel } from 'src/app/core/models/rulebook/rulebook-filters-model';
import { RegulationCheckboxReturnModel, RegulationCheckboxViewModel } from 'src/app/core/models/regulation/regulation-checkbox-view-model';
import { ConfirmSelfAssessedModel } from 'src/app/core/models/rulebook/confirm-self-assessed-model';
import { SelfAssessmentModalDialogComponent } from '../self-assessment/self-assessment-modal-dialog/self-assessment-modal-dialog.component';
import { OpenAssessModel } from 'src/app/core/models/self-assessment/openAssess-model';
import { SelfAssessmentNew } from 'src/app/core/models/self-assessmentT2/self-assessmentT2';
import { DatePipe } from '@angular/common';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { updateRulebookModel } from 'src/app/core/models/rulebook/updateRulebookDescription';
import { translateOthersToEnglishOutputModel } from 'src/app/core/models/translate/translateOutputModel';
import { translateOthersToEnglishInputModel } from 'src/app/core/models/translate/translateInputModel';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-change-detail',
  templateUrl: './change-detail.component.html',
  styleUrls: ['./change-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangeDetailComponent implements OnInit {
  @ViewChildren(TooltipDirective)
  tooltips!: QueryList<TooltipDirective>;
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;

  user: UserProfile;
  userAccessToken: UserProfile;
  regulation: RegulationModel;
  currentId = 0;
  isLoadingRegDetails = false;
  isLoadingFilters = false;
  linkedRules: Array<LinkedRule>;
  linkedRulesSorting: TableSortModel;
  linkedPolicies: LinkedPolicy[];
  linkedPoliciesSorting: TableSortModel;
  regulationDetailType = 0;
  isMovedToIA = false;
  selectedItemId = 0;
  regulationData: RegulationDataModel;
  selfAssessConfirmation: ConfirmSelfAssessedModel;
  selfAssessedId: number = 0;
  selfAssessmentNew: SelfAssessmentNew;

  ruleTopics: FilterViewModel[] = [];
  searchedTopics: FilterViewModel[] = [];
  searchTerm: FormControl = new FormControl();
  regulationDetail: RegulationDetailModel;
  toastModel: ToastViewModel;
  isToastShow = false;
  currentUserRole: string;

  ruleTopicsForToolTip = '';
  rulebookRuleTopic = '';
  isLoader = false;
  url = 'assets/d3/index.html?id=';
  rulebookUrl = 'assets/d3/rulebook_view_tree.html?id=';
  linkedPoliciesUrl = 'assets/d3/linked_policies.html?id=';
  iframeSRC: any = null;
  iframeSRC2: any = null;
  isChartExpanded = false;
  showChartCont = true;
  regulationInfo: RegulationDetail;
  siblingIds: SiblingRulebookModel;
  policyData: Array<Policies>;
  policies: Array<string>;
  section1: Array<string>;
  subSection: Array<string>;
  keywordSearch: KeywordModal;
  isLoading = false;
  isModalReq = false;
  modalRequirement: ModalAnalysisData;
  isKeyAlgo = false;
  keySearchText = '';
  policySearchText = '';
  highlightedData = '';
  isDisabledLink = false;
  sortedOneWord: Array<string> = [];
  sortedTwoWord: Array<string> = [];
  sortedMapCustomKeys: Array<string> = [];
  compareData: CompareItemModel;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  //ruleAnalyticData: RuleAnalyticData;
  allOneWord: Array<KeywordItem>;
  allTwoWord: Array<KeywordItem>;
  keywordData: KeywordDataList;
  ruleAnalyticList: Array<RuleAnalytic>;
  selectedRuleAnalytic: RuleAnalytic;
  endIndex = 0;
  totalCount = 0;
  isShowComparison = false;
  isKeywordLoading = false;
  summeryLoading = false;
  obligationLoading = false;
  riskLoading = false;
  controlLoading = false;

  //For New View Design -- Soustav
  isLoadingBar = false;
  isComment = false;
  // new variable declaration for new designs
  linkedConnection: LinkedConnectionModel;
  deletedLinkedConnection: LinkedConnectionModel;
  linkedAppliedAcross: LinkedAppliedAcrossModel;
  linkedConnectionIds: Array<LinkedConnectionIdModel>;
  controlDocumentCntrl: FormControl = new FormControl();
  filteredControlDocumentOptions!: string[];
  deletedLinkedAppliedAcross: LinkedAppliedAcrossModel;
  linkedAppliesAcrossIds: Array<LinkedAppliesAcrossIdModel>;
  isAppliesAcross = false;
  ownerComment = "";
  ownerCommentDetails: OwnerCommentModel;
  ownerCommentInJsonObject: any;
  ownerCommentInArray: any;
  controlDocumentSectionCntrl: FormControl = new FormControl();
  filteredControlDocumentSectionOptions!: string[];

  controlDocumentSubSectionCntrl: FormControl = new FormControl();
  filteredControlDocumentSubSectionOptions!: string[];
  linkedControlData: LinkedControlData;

  linkedControlList: Array<LinkedControlData>;
  isLinkedControlAddButtonDisabled: boolean = false;
  alertDialogModel: AlertDialogModel;
  isRequiredLinkedControl: boolean = false;
  linkedControlReferenceText: string = '';
  linkedControlGaps: string = '';
  isReferenceGapsDisabled: boolean = false;
  selectedLinkedControlId: number = 0;
  isReferenceTextExpan: boolean = true;
  isGapsExpan: boolean = true;
  isAttachmentLoader = false;
  attachmentDocument: Array<ControlDocument>;
  //options: string[] = ['One', 'Two', 'Three'];
  @ViewChild('ownerList') ownerList!: ElementRef;
  ownerDD: string[] = [];
  searchStr = '';
  @ViewChild('ownerAutocomplete')
  ownerAutocomplete!: any;
  @ViewChild('trigautoOwner')
  trigautoOwner!: MatAutocompleteTrigger;
  @ViewChild('ownerInput')
  ownerInput!: ElementRef<HTMLInputElement>;
  allSearchedOwner: FilterViewModelForOwner[] = [];
  searchOwnerCntrl: FormControl = new FormControl();
  ownerExternalIdList: string[] = [];
  isExpand = false;
  isOwnerPresent = false;
  tabPressed: boolean = false;
  isUpdateComment = false;
  ownerCommentKey = '';
  isSelfAssess = false;
  // public Editor = customBuild;
  componentOpenType!: string;
  isSummaryShow: boolean = true;
  isActionShow: boolean = true;
  isAdditionalShow: boolean = true;
  isConnectionShow: boolean = true;
  isOrganizationShow: boolean = true;
  isVersioned = false;
  versionNo = 0;
  rulebookIdList: number[] = [];
  filterPersistenceKey = 'rulebookIdList';
  currentRulebookId = 0;
  rulebookFilter: RulebookFilterModel;
  rulebookFilterPersistenceKey = 'rulebookFilters';
  ruleBookViewCloseData: RegulationCheckboxViewModel;
  checkboxReturnModel: RegulationCheckboxReturnModel;
  rulebookIdForVersion: number = 0;
  isInnerModel = false;
  //For New Template in Self Assessment
  divisionId: number;
  formattedApproveDate: string | null;
  formattedInterDate: string | null;
  formattedJudgeDate: string | null;
  formattedGapDate: string | null;
  // interpretationDetailsData: any;
  judgementDetailsData: any;
  templateNo = 1;
  accessType: revisionHistoryAccessTypeEnum = revisionHistoryAccessTypeEnum.Readonly;
  isEditorShow = false;
  divisionName: string;
  selfAssessmentApprovalList: Array<SelfAssessmentNew>;
  capturedSelfId: number = 0;
  isShowDescriptionEditor: boolean = false;
  descriptionInEditor: string = '';
  WindowOpen: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      id: number;
      detailType: number;
      ruleArr: RulebookModel[];
      filterType: string;
      type: string;
      isVersion: boolean;
      rulebookId: number;
      isInnerModel: boolean;
    },
    public dialogRef: MatDialogRef<ChangeDetailComponent>,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private regulationService: RegulationService,
    private gdprService: GDPRService,
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionService,
    public authService: AuthService,
    public commonService: CommonService,
    public dialog: MatDialog,
    private userService: UserManagementService,
    public sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    private _globalService: GlobalService
  ) {
    this.selfAssessmentApprovalList = [];
    this.formattedApproveDate = "";
    this.formattedInterDate = "";
    this.formattedJudgeDate = "";
    this.formattedGapDate = "";
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    this.attachmentDocument = [];
    this.selfAssessmentNew = new SelfAssessmentNew();
    // this.selfAssessmentNew.interpretationDetails = null;
    this.ruleBookViewCloseData = new RegulationCheckboxViewModel();
    this.checkboxReturnModel = new RegulationCheckboxReturnModel();
    this.regulation = new RegulationModel();
    this.linkedRules = new Array<LinkedRule>();
    this.linkedRulesSorting = new TableSortModel();
    this.linkedPolicies = new Array<LinkedPolicy>();
    this.linkedPoliciesSorting = new TableSortModel();
    this.user = new UserProfile();
    this.userAccessToken = new UserProfile();
    this.regulationDetail = new RegulationDetailModel();
    this.toastModel = new ToastViewModel();
    this.regulationInfo = new RegulationDetail();
    this.sessionService.isLibraryTabActive = true;
    this.siblingIds = new SiblingRulebookModel();
    this.currentUserRole = '';
    this.policyData = [];
    this.policies = [];
    this.section1 = [];
    this.subSection = [];
    this.keywordSearch = new KeywordModal();
    //this.ruleAnalyticData = new RuleAnalyticData();
    this.allOneWord = [];
    this.allTwoWord = [];
    this.keywordData = new KeywordDataList();
    this.ruleAnalyticList = [];
    this.selectedRuleAnalytic = new RuleAnalytic();
    this.modalRequirement = new ModalAnalysisData();
    this.regulationData = new RegulationDataModel();
    this.compareData = new CompareItemModel();
    this.linkedConnection = new LinkedConnectionModel();
    this.deletedLinkedConnection = new LinkedConnectionModel();
    this.linkedAppliedAcross = new LinkedAppliedAcrossModel();
    const regulationFilter = new RegulationFilterModel();
    this.rulebookFilter = new RulebookFilterModel();
    this.selfAssessConfirmation = new ConfirmSelfAssessedModel();
    // this.ownerList = [];
    //delete conformation modal for new designs
    this.alertDialogModel = new AlertDialogModel();
    this.linkedConnectionIds = [];
    this.linkedAppliesAcrossIds = [];
    this.deletedLinkedAppliedAcross = new LinkedAppliedAcrossModel();
    this.ownerCommentDetails = new OwnerCommentModel();
    if (data && data.id >= 0 && data?.detailType) {
      regulationFilter.Id = data.id;
      this.regulationDetailType = data.detailType;
      this.currentId = data.id;
      this.regulationData.id = data.id;
      this.componentOpenType = data.type;
      this.isInnerModel = data.isInnerModel;
      if (data.isVersion) {
        this.isVersioned = true;
        this.rulebookIdForVersion = data.rulebookId;
      }
    } else {
      regulationFilter.Id = Number(this.route.snapshot.queryParamMap.get('id'));
      this.regulationDetailType = Number(
        this.route.snapshot.queryParamMap.get('detailType')
      );
      this.currentId = Number(this.route.snapshot.queryParamMap.get('id'));
      this.regulationData.id = Number(
        this.route.snapshot.queryParamMap.get('id')
      );
      this.isVersioned = (this.route.snapshot.queryParamMap.get('isVersion')) == "true" ? true : false;
      this.rulebookIdForVersion = Number(this.route.snapshot.queryParamMap.get('rulebookId'));
    }
    if (data && data?.id && data?.detailType && data?.isVersion) {

    }
    this.keywordSearch = new KeywordModal();
    this.isKeyAlgo = false;
    if (this.regulationDetailType === 2) {
      let regulationId = 0;
      if (regulationFilter) {
        regulationFilter.UserId = this.user.userId;
        regulationId = regulationFilter.Id as number;
      } else {
        regulationId = Number(this.route.snapshot.queryParamMap.get('id'));
      }
      this.currentRulebookId = regulationId;

      this.getRelatedIds();
      this.iframeSRC2 = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.linkedPoliciesUrl + this.currentId
      );
      //this.compareParentDescription(data.id);
      //this.getRuleAnalytic();
    } else {
      // this.getRegulation(regulationFilter);
    }
    //code for new designs for bottom section
    this.linkedControlData = new LinkedControlData();
    this.linkedControlList = [];
    //get RulebookId List
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as number[];
    this.rulebookIdList = persistFilter ? persistFilter : [];
    this.divisionName = this.fetchFromBrowser("selectedDivisionName");
  }

  async ngOnInit(): Promise<void> {
    const persistFilter = JSON.parse(this.fetchFromBrowser(
      this.filterPersistenceKey
    ) as string) as RulebookFilterModel;
    if (persistFilter) {
      this.rulebookFilter = persistFilter;
    }
    await this.getUserProfile();

    // this.userAccessToken = await this.sessionService.getLoginUserInfo().toPromise();
    const templateNo: number = await this.gdprService.getSelfAssessmentTemplate(this.user.lastUsedJurisdictionId).toPromise();
    this.templateNo = templateNo;
    if (this.regulationDetailType === 2) {
      this.getRulebook(this.currentRulebookId);
    }

    this.getMasterFilters();
    this.OrganisationalDataMappingDropdowns();
    this.getOwnerDD();
    this.fetchPolicies();
    // const inputElement = this.elementRef.nativeElement.querySelector('#myInput');
    // this.renderer.selectRootElement(inputElement).focus();
  }
  get searchedOwner(): FilterViewModelForOwner[] {
    if (this.searchOwnerCntrl.value != null) {
      const filterValue = this.searchOwnerCntrl.value.toLowerCase();
      return this.allSearchedOwner.filter((obj) =>
        obj.name.toLowerCase().includes(filterValue)
      );
    }
    return this.allSearchedOwner;
  }

  newWindowClick() {
    this.WindowOpen = true;
  }

  addOwner(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.ownerAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.ownerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.ownerDD as string[]).push(value);
          this.regulationService
            .addUpdateOwner(this.ownerDD.toString(), this.regulation.id)
            .subscribe((res: any) => { });
          this.ruleBookViewCloseData.ownerList = this.ownerDD.toString();
        }
      }
      event.chipInput!.clear();
      this.searchOwnerCntrl.setValue(null);
    }
  }

  selectedOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.ownerDD) {
      let sameValueRow = this.ownerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.ownerDD.push(event.option.viewValue);
        this.regulationService
          .addUpdateOwner(this.ownerDD.toString(), this.regulation.id)
          .subscribe((res: any) => { });
        this.ruleBookViewCloseData.ownerList = this.ownerDD.toString();
      }
    } else {
      this.ownerDD = [];
      this.ownerDD.push(event.option.viewValue);
      this.regulationService
        .addUpdateOwner(this.ownerDD.toString(), this.regulation.id)
        .subscribe((res: any) => { });
      this.ruleBookViewCloseData.ownerList = this.ownerDD.toString();
    }
    if (this.ownerInput) {
      this.ownerInput.nativeElement.value = '';
    }
    this.searchOwnerCntrl.setValue(null);
    this.searchOwnerCntrl.disable();
    this.searchOwnerCntrl.enable();
  }

  getOwnerDD() {
    this.regulationService
      .getUserListForOwner()
      .subscribe((res: Array<FilterViewModelForOwner>) => {
        // this.searchedOwner = res;
        this.allSearchedOwner = res;
        // this.searchOwnerCntrl.valueChanges.subscribe((term: any) => {
        //   this.searchedOwner = term ? this.filterOwner(term) : res;
        // });
      });
  }
  filterOwner(search: any): any {
    let sameValue = this.ownerExternalIdList.filter(
      (obj) => obj === search.externalUserId
    );
    if (sameValue.length == 0) {
      this.ownerExternalIdList.push(search.externalUserId);
    }
    return this.searchedOwner.filter((option) =>
      option.name.toLowerCase().includes(search.value.toLowerCase())
    );
  }
  ownerIsUser(): any {
    if (
      this.ownerExternalIdList != null &&
      this.ownerExternalIdList.length > 0
    ) {
      const isValueIncluded = this.ownerExternalIdList.includes(
        this.user.externalUserId
      );
      if (isValueIncluded) {
        this.isOwnerPresent = true;
      }
    }
  }
  expandCollapse() {
    this.isExpand = !this.isExpand;
  }
  removeOwner(status: string): void {
    const index = (this.ownerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.ownerDD as string[]).splice(index, 1);
      (this.ownerExternalIdList as string[]).splice(index, 1);
      this.regulationService
        .addUpdateOwner(this.ownerDD.toString(), this.regulation.id)
        .subscribe((res: any) => { });
      this.ruleBookViewCloseData.ownerList = this.ownerDD.toString();
    }
  }
  @HostListener('window:scroll')
  scrollHandler(event: any) {
    if (this.ownerAutocomplete && this.ownerAutocomplete.panelOpen) {
      this.trigautoOwner.closePanel();
      // this.ownerInput.nativeElement.blur();
    }
  }

  openRulesConnectionDialog(): void {
    this.linkedConnection = new LinkedConnectionModel();
    this.linkedConnection.currentID = this.regulation.id;
    if (this.regulation.connections) {
      const ids = this.regulation.connections.split(',');
      ids.forEach((element) => {
        this.linkedConnection.linkedConnections.push(+element);
      });
    }
    this.isAppliesAcross = false;
    const dialogRef = this.dialog.open(RulesConnectionComponent, {
      width: '1000px',
      data: [this.linkedConnection, this.isAppliesAcross],
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.linkedConnection = result[0];
        this.deletedLinkedConnection = result[1];
        this.saveLinkedConnection();
      }
    });
  }

  saveLinkedConnection(): void {
    this.isLoading = true;
    this.regulationService
      .saveLinkedConnection(this.linkedConnection)
      .subscribe((result: LinkedConnectionModel) => {
        if (this.linkedConnection.linkedConnections.length > 0 && this.deletedLinkedConnection.linkedConnections.length > 0) {
          this.regulationService
            .deleteLinkedConnection(this.deletedLinkedConnection)
            .subscribe((res: any) => {
              this.deletedLinkedConnection = new LinkedConnectionModel();
            });
        }
        this.isLoading = false;
        this.linkedConnection = new LinkedConnectionModel();
        this.regulation.connections = result.linkedConnections.toString();
        if (this.regulation.connections == '') {
          this.linkedConnectionIds = [];
        }
        if (this.regulation.connections) {
          this.getLinkedIds();
        }
      });
  }

  getLinkedIds(): void {
    this.regulationService
      .getLinkedConnectionIds(this.regulation.connections)
      .subscribe((result: LinkedConnectionIdModel[]) => {
        this.linkedConnectionIds = result;
      });
  }

  async getUserProfile() {
    this.user = await this._globalService.getLoginUserData();
    if (this.user && this.user.roleId > 0) {
      this.fetchCurrentUserRole();

    }
    // this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
    //   this.user = user;
    //   if (this.user && this.user.roleId > 0) {
    //     this.fetchCurrentUserRole();
    //   }
    // });
  }

  tabChanged(event: any): void {
    //document.getElementById('tabView').scrollIntoView();
    if (event.index === 2) {
      this.fetchPolicies();
      //this.getRuleAnalytic();
    }
  }

  eventHandler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
  }

  getMasterFilters(): void {
    this.isLoadingFilters = true;
    this.regulationService.getMasterFilters().subscribe(
      (data: MasterFilterModel) => {
        this.isLoadingFilters = false;
        this.ruleTopics = data.ruleTopics;
        this.searchedTopics = this.ruleTopics;

        this.searchTerm.valueChanges.subscribe((term) => {
          this.searchedTopics = term
            ? this.filterValues(term)
            : this.ruleTopics;
        });
      },
      (error: HttpErrorResponse) => {
        this.isLoadingFilters = false;
        Logger.log(this.constructor.name, error.error);
      }
    );
  }

  fetchCurrentUserRole(): void {
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
      });
  }
  closeAction() {
    this.ruleBookViewCloseData.ownerList = this.ownerDD.toString();
    this.dialogRef.close(this.ruleBookViewCloseData);
  }

  filterValues(search: string): any {
    return this.searchedTopics.filter(
      (value) => value.name.toLowerCase().indexOf(search.toLowerCase()) === 0
    );
  }

  getRelatedIds(): void {
    if (this.isVersioned) {
      this.regulationService
        .GetRulebookVersionHistoryIds(this.rulebookIdForVersion)
        .subscribe((result: number[]) => {
          this.rulebookIdList = result;
        });
    }
    else {
      this.regulationService
        .getRuleSiblings(this.currentId, this.rulebookFilter)
        .subscribe((result: number[]) => {
          this.rulebookIdList = result;
          // this.siblingIds = result;
        });
    }
  }

  sortLinkedRules(key: string): void {
    this.linkedRulesSorting.SortKey = key;
    this.linkedRules = this.linkedRulesSorting.IsDesc
      ? _.sortBy(this.linkedRules, key).reverse()
      : _.sortBy(this.linkedRules, key);
    this.linkedRulesSorting.IsDesc = !this.linkedRulesSorting.IsDesc;
  }

  sortLinkedPolicies(key: string): void {
    this.linkedPoliciesSorting.SortKey = key;
    // tslint:disable-next-line:max-line-length
    this.linkedPolicies = this.linkedPoliciesSorting.IsDesc
      ? _.sortBy(this.linkedPolicies, key).reverse()
      : _.sortBy(this.linkedPolicies, key);
    this.linkedPoliciesSorting.IsDesc = !this.linkedPoliciesSorting.IsDesc;
  }

  routeToChangeViewer(linkedRule: string[]): void {
    let regulationFilter = new RegulationFilterModel();
    regulationFilter = this.initFilters();
    regulationFilter.Filters =
      regulationFilter.Filters as RegulationFilterViewModel;
    regulationFilter.Filters.LinkedRules = linkedRule;
    this.saveOnBrowser('regulationFilter', JSON.stringify(regulationFilter));

    setTimeout(() => {
      this.router.navigate(['/change-viewer']);
    }, 100);
  }

  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  initFilters(): RegulationFilterModel {
    const regulationFilter = new RegulationFilterModel();
    regulationFilter.Filters = new RegulationFilterViewModel();
    regulationFilter.FromDate = MasterHelper.getDateStr(30);
    regulationFilter.ToDate = MasterHelper.getDateStr(0);
    regulationFilter.SortKey = 'Date';
    regulationFilter.SkipCount = 0;
    regulationFilter.Regulator = [];
    regulationFilter.MappingID = [];
    regulationFilter.Status = [];
    regulationFilter.IsAdvance = true;

    return regulationFilter;
  }

  Close(): void {
    this.tooltips.forEach((tooltip: TooltipDirective) => {
      tooltip.hide();
    });
  }

  addSelfAssessment(): void {
    this.isLoader = true;
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    this.divisionName = this.fetchFromBrowser("selectedDivisionName");
    this.regulationDetail.regulation = this.regulation;
    this.regulationDetail.screenUrl = this.router.url;
    this.regulation.owner = this.ownerDD.join(',');
    this.regulation.jurisdiction = this.divisionName;
    this.regulationService
      .moveToSelfAssessment(this.regulation, this.router.url, this.divisionId)
      .subscribe((data: any) => {
        this.regulationDetail = new RegulationDetailModel();
        this.isLoader = false;
        if (data.result > 0) {
          this.toastModel.Title = 'Success';
          this.toastModel.Type = 'success';
          this.toastModel.Message = 'Regulation Moved to Self Assessment';
        } else {
          this.toastModel.Title = 'Warning';
          this.toastModel.Type = 'warning';
          this.toastModel.Message = 'Regulation not Moved to Self Assessment';
        }
        this.isToastShow = true;
        setTimeout(() => {
          this.isToastShow = false;
          // window.location.href = '/self-assessment/details/self/'+data.result+'';
          this.openAssessmentPopup(data.result);
          this.saveOnBrowser('_said', data.result);
        }, 3500);
      });
  }

  openPopUp(id: number): void {
    this.userService
      .getUserJurisdictions()
      .subscribe((result: ItemIdModel[]) => {
        if (result && result.length === 1) {
          const selectedJuridiction =
            MasterHelper.getStringArrayFromObjectArray(result);
          this.addImpactAssessment(selectedJuridiction, id);
        } else {
          this.selectedItemId = id;
          const dialogRef = this.dialog.open(JurisdictionDialogComponent, {
            width: '450px',
            data: { result: result, type: 'assess' },
            //data: result
          });
          dialogRef.afterClosed().subscribe((response) => {
            if (response) {
              this.addImpactAssessment(response, this.selectedItemId);
            } else {
              this.selectedItemId = 0;
            }
          });
        }
      });
  }

  addImpactAssessment(jurisdictions: Array<string>, id: number): void {
    this.isMovedToIA = true;
    const itemInfoDto = new ItemInfoDto();
    itemInfoDto.id = id;
    itemInfoDto.screenUrl = this.router.url;
    itemInfoDto.jurisdictions = jurisdictions;
    this.gdprService
      .moveToImpactAssessment(itemInfoDto)
      .subscribe((data: any) => {
        this.alertMessage(data);
      });
  }

  alertMessage(data: any): void {
    if (data.result?.resultId > 0 && data.result.status) {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Regulation Moved to Impact Assessment';
    } else if (!data.result?.status && data.result?.message) {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = data.result?.message;
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message =
        'Impact Assessment on this Change Id already exists';
    }
    this.isToastShow = true;
    setTimeout(() => {
      this.isMovedToIA = false;
      this.isToastShow = false;
      window.location.href =
        '/impact-assessment/details/impact/' + data.result.resultId;
      this.saveOnBrowser('_iaid', data.result.resultId);
    }, 3500);
  }

  expandPanel(): void {
    this.showChartCont = false;
    this.isChartExpanded = !this.isChartExpanded;
    if (!this.isChartExpanded) {
      this.isShowtabs();
    }
    else {
      this.hideShowtabs();
      this.isOrganizationShow = true;
    }
    setTimeout(() => {
      this.showChartCont = true;
    }, 100);
  }

  openDialog(): void {
    if (this.regulation.regulationDetails) {
      this.regulationInfo = this.regulation.regulationDetails;
    }
    this.regulationInfo.title = this.regulation.title;
    this.regulationInfo.type = this.regulation.pubType;
    this.regulationInfo.filterType =
      this.regulationDetailType === 2 ? 'Linked Updates' : '';
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationInfo,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateRegulationDetail(result, this.regulation.id);
      } else {
        this.regulationInfo = new RegulationDetail();
      }
    });
  }

  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    regulation.regulationId = id;
    regulation.userId = this.user.externalUserId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    this.regulationService.updateRegulationInfo(regulation).subscribe(() => {
      this.successAlert('Successfully updated');
      const regulationFilter = new RegulationFilterModel();
      regulationFilter.Id = Number(this.route.snapshot.queryParamMap.get('id'));
      window.location.href = '/change-viewer/open';
    });
    //}
  }

  updateRulebookAction(type: string): void {
    this.gdprService.disableRulebook(this.currentId, type).subscribe((res: any) => {
      if (type == "Applicable") {
        this.ruleBookViewCloseData.IsApplicable = res.result.value;
      }
      else if (type == "Read") {
        this.ruleBookViewCloseData.IsRead = res.result.value;
      }
      else {
        this.ruleBookViewCloseData.IsOperative = res.result.value;
      }
      this.successAlert('Successfully updated');
    });
  }

  // changed for new view design
  fetchPolicies(): void {
    this.isLoading = true;
    this.policies = [];
    this.gdprService
      .getRulebookDocumentControl(this.policySearchText)
      .subscribe((result: Array<string>) => {
        this.isLoading = false;
        this.policies.push(...result);
        this.filteredControlDocumentOptions = this.policies;
      });
  }

  // changed for new view design and getting data using api
  getSectionList(policy: string): void {
    this.linkedControlData.Control = policy;
    this.controlDocumentSectionCntrl.setValue('');
    this.controlDocumentSubSectionCntrl.setValue('');
    this.filteredControlDocumentSectionOptions = [];
    this.filteredControlDocumentSubSectionOptions = [];
    this.section1 = [];
    this.subSection = [];
    this.linkedControlData.ControlSection = '';
    this.linkedControlData.ControlSubSection = '';
    if (this.linkedControlData.Control) {
      this.isLoading = true;
      this.gdprService
        .getRulebookDocumentControlSection(this.linkedControlData.Control)
        .subscribe((result: Array<string>) => {
          this.isLoading = false;
          this.section1.push(...result);
          this.filteredControlDocumentSectionOptions = this.section1;
        });
    }
  }

  // changed for new view design and getting data using api
  getSubSectionList(section: string): void {
    this.linkedControlData.ControlSection = section;
    this.controlDocumentSubSectionCntrl.setValue('');
    this.filteredControlDocumentSubSectionOptions = [];
    this.subSection = [];
    this.linkedControlData.ControlSubSection = '';
    if (
      this.linkedControlData.Control &&
      this.linkedControlData.ControlSection
    ) {
      this.isLoading = true;
      this.gdprService
        .getRulebookDocumentControlSubSection(
          this.linkedControlData.Control,
          this.linkedControlData.ControlSection
        )
        .subscribe((result: Array<string>) => {
          this.isLoading = false;
          this.subSection.push(...result);
          this.filteredControlDocumentSubSectionOptions = this.subSection;
        });
    }
  }

  //change for new view design
  saveRuleAnalytic(): void {
    if (!this.linkedControlData.Control) {
      this.warningAlert('Document Control is required');
    } else {
      this.isLinkedControlAddButtonDisabled = true;
      this.isLoading = true;
      let maxId = 0;
      if (this.linkedControlList?.length > 0) {
        maxId = this.linkedControlList.reduce(
          (max, item) => (item.Id > max ? item.Id : max),
          0
        );
      }
      this.linkedControlData.Id = maxId + 1;
      this.gdprService
        .saveLinkedControlData(this.linkedControlData, this.currentId)
        .subscribe((data: Array<LinkedControlData>) => {
          this.isLoading = false;
          this.linkedControlList = data;
          this.controlDocumentSectionCntrl.setValue('');
          this.controlDocumentSubSectionCntrl.setValue('');
          this.controlDocumentCntrl.setValue('');
          this.linkedControlData = new LinkedControlData();
          this.isLinkedControlAddButtonDisabled = false;
          this.fetchPolicies();
        });
    }
  }

  // getRuleAnalytic(): void {
  //   const ruleIds = new Array<number>();
  //   ruleIds.push(this.currentId);
  //   this.gdprService
  //     .getRuleAnalyticList(ruleIds)
  //     .subscribe((result: Array<RuleAnalytic>) => {
  //       this.ruleAnalyticList = result;
  //       this.totalCount = result.length;
  //       this.endIndex =
  //         this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
  //       if (result && result.length > 0) {
  //         this.changeRuleAnalytic(result[0]);
  //       } else {
  //         this.clearRuleAnalyticData();
  //       }
  //     });
  // }

  onEnterSearchKeys(event: any, filter: string): void {
    switch (filter) {
      case 'Keyword':
        if (this.keySearchText.length > 1) {
          this.searchKeys(filter);
        } else {
          this.keywordData.oneWordList = this.allOneWord;
          this.keywordData.twoWordList = this.allTwoWord;
        }
        break;
      case 'Policy':
        if (event.keyCode === 13) {
          this.searchKeys(filter);
        }
        break;
    }
  }

  searchKeys(filter: string): void {
    switch (filter) {
      case 'Keyword':
        const searchedResult = Array<KeywordItem>();
        const searchedResult2 = Array<KeywordItem>();
        if (this.keySearchText) {
          this.allOneWord.forEach((element) => {
            if (
              element.keyword
                .toUpperCase()
                .includes(this.keySearchText.toUpperCase())
            ) {
              searchedResult.push(element);
            }
          });
          this.allTwoWord.forEach((element) => {
            if (
              element.keyword
                .toUpperCase()
                .includes(this.keySearchText.toUpperCase())
            ) {
              searchedResult2.push(element);
            }
          });
          this.keywordData.oneWordList = searchedResult;
          this.keywordData.twoWordList = searchedResult2;
        } else {
          this.keywordData.oneWordList = this.allOneWord;
          this.keywordData.twoWordList = this.allTwoWord;
        }
        break;
      case 'Policy':
        this.fetchPolicies();
        break;
    }
  }

  // changeRuleAnalytic(obj: RuleAnalytic): void {
  //   if (
  //     this.selectedRuleAnalytic.id > 0 &&
  //     this.selectedRuleAnalytic.id === obj.id
  //   ) {
  //     this.clearRuleAnalyticData();
  //   } else {
  //     this.getSortedItems(obj);
  //     this.selectedRuleAnalytic = obj;
  //     this.ruleAnalyticData.id = obj.id;
  //     this.ruleAnalyticData.oneWordList = this.sortedOneWord;
  //     this.ruleAnalyticData.twoWordList = this.sortedTwoWord;
  //     this.ruleAnalyticData.mapCustomKeys = this.sortedMapCustomKeys;
  //     this.ruleAnalyticData.gaps = obj.gap ? obj.gap.split('|') : [];
  //     this.ruleAnalyticData.comments = obj.comment
  //       ? obj.comment.split('|')
  //       : [];
  //     this.ruleAnalyticData.policy = obj.policyName;
  //     this.getSectionList(obj.policyName);
  //     this.ruleAnalyticData.policySection = obj.policySection;
  //     this.getSubSectionList(obj.policySection);
  //     this.ruleAnalyticData.policySubSection = obj.policySubSection;
  //   }
  // }

  // getSortedItems(obj: RuleAnalytic): void {
  //   this.sortedMapCustomKeys = obj.mapCustomKeys
  //     ? obj.mapCustomKeys.split('|')
  //     : [];
  //   this.sortedOneWord = [];
  //   this.sortedTwoWord = [];
  //   if (obj.oneWord) {
  //     obj.oneWord.split('|').forEach((oneWord) => {
  //       if (this.keywordData.oneWordList.some((a) => a.keyword === oneWord)) {
  //         this.sortedOneWord.push(oneWord);
  //       } else {
  //         this.sortedMapCustomKeys.push(oneWord);
  //       }
  //     });
  //   }
  //   if (obj.twoWord) {
  //     obj.twoWord.split('|').forEach((twoWord) => {
  //       if (this.keywordData.twoWordList.some((a) => a.keyword === twoWord)) {
  //         this.sortedTwoWord.push(twoWord);
  //       } else {
  //         this.sortedMapCustomKeys.push(twoWord);
  //       }
  //     });
  //   }
  //   this.sortedOneWord = MasterHelper.getDistinctValues(this.sortedOneWord);
  //   this.sortedTwoWord = MasterHelper.getDistinctValues(this.sortedTwoWord);
  //   this.sortedMapCustomKeys = MasterHelper.getDistinctValues(
  //     this.sortedMapCustomKeys
  //   );
  // }

  // clearRuleAnalyticData(): void {
  //   this.selectedRuleAnalytic = new RuleAnalytic();
  //   this.ruleAnalyticData.id = 0;
  //   this.ruleAnalyticData.oneWordList = [];
  //   this.ruleAnalyticData.twoWordList = [];
  //   this.ruleAnalyticData.mapCustomKeys = [];
  //   this.ruleAnalyticData.gaps = [];
  //   this.ruleAnalyticData.comments = [];
  //   this.fetchPolicies();
  //   if (this.policies.length > 0) {
  //     this.ruleAnalyticData.policy = this.policies[0];
  //     this.getSectionList(this.policies[0]);
  //   }
  // }

  compareParentDescription(id: number): void {
    this.gdprService
      .compareDescriptionData(id)
      .subscribe((data: CompareItemModel) => {
        this.compareData = data;
        if (this.compareData && !this.compareData.secondItem) {
          this.isShowComparison = false;
        }
      });
  }

  warningAlert(text: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = text;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }

  successAlert(text: string): void {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
    this.toastModel.Message = text;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }

  public scrollRight(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
    });
  }

  public scrollLeft(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }

  getSummary(id: number, type: string) {
    var summaryArray: Array<RulebookSummary> = [];
    this.gdprService
      .getSummary(id, type)
      .subscribe((data: Array<RulebookSummary>) => {
        summaryArray = data;
        if (summaryArray && summaryArray?.length > 1) {
          const dialogRef = this.dialog.open(RulebookSummaryComponent, {
            width: '1000px',
            data: { data: summaryArray, type: type, id: id },
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result && result > 0) {
              this.setSummary(id, type, result);
            }
          });
        } else {
          let length = summaryArray && summaryArray?.length == 1 ? 1 : 0;
          this.generateSummary(id, type, length);
        }
      });
  }

  async generateSummary(
    id: number,
    type: string,
    lastSummaryLength: number
  ): Promise<void> {
    if (type == 'Obligation') {
      this.obligationLoading = true;
    }
    if (type == 'Risk') {
      this.riskLoading = true;
    }
    if (type == 'Controls') {
      this.controlLoading = true;
    }
    if (type == 'Summary') {
      this.summeryLoading = true;
    }
    this.gdprService.generateSummary(id, type).subscribe((data: any) => {
      if (data && type == 'Obligation' && data.result?.result != 'error') {
        this.regulation.obligation = data.result?.result;
        this.obligationLoading = false;
        if (lastSummaryLength == 1) {
          this.getSummary(id, type);
        }
      } else if (data && type == 'Risk' && data.result?.result != 'error') {
        this.regulation.risks = data.result?.result;
        this.riskLoading = false;
        if (lastSummaryLength == 1) {
          this.getSummary(id, type);
        }
      } else if (data && type == 'Controls' && data.result?.result != 'error') {
        this.regulation.controls = data.result?.result;
        this.controlLoading = false;
        if (lastSummaryLength == 1) {
          this.getSummary(id, type);
        }
      } else if (data && type == 'Summary' && data.result?.result != 'error') {
        this.regulation.summary = data.result?.result;
        this.summeryLoading = false;
        if (lastSummaryLength == 1) {
          this.getSummary(id, type);
        }
      }
    });
  }
  setSummary(rulebookId: number, type: string, id: number) {
    let input = new setSummaryDetails();
    input.id = id;
    input.rulebookId = rulebookId;
    input.type = type;
    this.gdprService.setSummary(input).subscribe((data: any) => {
      if (data && type == 'Obligation' && data?.result != 'error') {
        this.regulation.obligation = data?.result;
        //this.obligationExpand = true;
        this.summeryLoading = false;
      } else if (data && type == 'Risk' && data?.result != 'error') {
        this.regulation.risks = data?.result;
        //this.riskExpand = true;
        this.summeryLoading = false;
      } else if (data && type == 'Controls' && data.result?.result != 'error') {
        this.regulation.controls = data?.result;
        //this.controlExpand = true;
        this.summeryLoading = false;
      } else if (data && type == 'Summary' && data.result?.result != 'error') {
        this.regulation.summary = data?.result;
        this.summeryLoading = false;
      }
    });
  }
  showText(description: string): any {
    if (description) {
      const descArr = description.split('\n');
      const strArr = new Array<string>();
      descArr.forEach((item) => {
        if (item) {
          strArr.push('<p>' + item + '</p>');
        }
      });
      description = strArr.join(' ');
    }
    return description;
  }

  // Organisational Data Mapping
  OrganisationalDataMappingDropdowns() {
    this.controlDocumentCntrl.valueChanges.subscribe((term: any) => {
      this.filteredControlDocumentOptions = term
        ? this.filterControlDocument(term)
        : this.policies;
    });
    this.controlDocumentSectionCntrl.valueChanges.subscribe((term: any) => {
      this.filteredControlDocumentSectionOptions = term
        ? this.filterControlDocumentSection(term)
        : this.section1;
    });
    this.controlDocumentSubSectionCntrl.valueChanges.subscribe((term: any) => {
      this.filteredControlDocumentSubSectionOptions = term
        ? this.filterControlDocumentSubSection(term)
        : this.subSection;
    });
  }
  private filterControlDocument(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.policies.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  private filterControlDocumentSection(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.section1.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  private filterControlDocumentSubSection(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.subSection.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  subSectionSelected(section: string) {
    this.linkedControlData.ControlSubSection = section;
  }

  removeRuleAnalytic(id: number): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Delete Item') {
        // this.isLoading = true;
        this.linkedControlList = this.linkedControlList.filter(
          (item) => item.Id !== id
        );
        let jsonString: any = null;
        if (this.linkedControlList.length > 0) {
          jsonString = JSON.stringify(this.linkedControlList);
        }
        this.gdprService
          .UpdateRuleLinkedControl(jsonString, this.currentId)
          .subscribe((result: any) => {
            this.removeLinkedControlAttachment(id);
            //this.isLoading = false;
          });
      }
    });
  }
  removeLinkedControlAttachment(id: number): void {
    this.isLoading = true;
    this.gdprService
      .RemoveControlDocumentAttachment(this.currentId, id)
      .subscribe((result: Array<ControlDocument>) => {
        this.attachmentDocument = result;
        this.fetchAllControlDocumentAttachment();
        this.isLoading = false;
      });
  }
  copyRuleAnalytic(obj: LinkedControlData): void {
    let copyObject: LinkedControlData = new LinkedControlData();
    let maxId = this.linkedControlList.reduce(
      (max, item) => (item.Id > max ? item.Id : max),
      0
    );
    copyObject.Id = maxId + 1;
    copyObject.Control = obj.Control;
    copyObject.ControlSection = obj.ControlSection;
    copyObject.ControlSubSection = obj.ControlSubSection;
    copyObject.ReferenceText = obj.ReferenceText;
    copyObject.Gaps = obj.Gaps;
    let jsonString: any = '';
    this.linkedControlList.push(copyObject);
    if (this.linkedControlList.length > 0) {
      jsonString = JSON.stringify(this.linkedControlList);
    }
    this.isLoading = true;
    this.gdprService
      .UpdateRuleLinkedControl(jsonString, this.currentId)
      .subscribe((result: any) => {
        this.isLoading = false;
      });
  }
  // changed for new view design and getting data using api
  linkedControlChange(policy: string): void {
    this.linkedControlData.Control = policy;
    this.controlDocumentSectionCntrl.setValue('');
    this.controlDocumentSubSectionCntrl.setValue('');
    this.filteredControlDocumentSectionOptions = [];
    this.filteredControlDocumentSubSectionOptions = [];
    this.section1 = [];
    this.subSection = [];
    this.linkedControlData.ControlSection = '';
    this.linkedControlData.ControlSubSection = '';
  }

  // changed for new view design and getting data using api
  linkedControlSectionChange(section: string): void {
    this.linkedControlData.ControlSection = section;
    this.controlDocumentSubSectionCntrl.setValue('');
    this.filteredControlDocumentSubSectionOptions = [];
    this.subSection = [];
    this.linkedControlData.ControlSubSection = '';
  }
  clickLinkedControlRow(obj: LinkedControlData) {
    this.linkedControlData.Control = obj.Control;
    this.linkedControlData.ControlSection = obj.ControlSection;
    this.linkedControlData.ControlSubSection = obj.ControlSubSection;
    this.linkedControlData.ReferenceText = obj.ReferenceText;
    this.linkedControlData.Gaps = obj.Gaps;
    this.linkedControlData.Id = 0;
    this.controlDocumentCntrl.setValue(this.linkedControlData.Control);
    this.controlDocumentSectionCntrl.setValue(
      this.linkedControlData.ControlSection
    );
    this.controlDocumentSubSectionCntrl.setValue(
      this.linkedControlData.ControlSubSection
    );
    this.filteredControlDocumentSectionOptions = [];
    this.filteredControlDocumentSubSectionOptions = [];
    this.section1 = [];
    this.subSection = [];
  }
  openAppliesAcrossDialog() {
    this.linkedAppliedAcross = new LinkedAppliedAcrossModel();
    this.linkedAppliedAcross.currentID = this.regulation.id;
    this.isAppliesAcross = true;

    if (this.regulation.appliesAcross) {
      const ids = this.regulation.appliesAcross.split(',');
      ids.forEach((element) => {
        this.linkedAppliedAcross.linkedAppliesAcrossIds.push(+element);
      });
    }
    const dialogRef = this.dialog.open(RulesConnectionComponent, {
      width: '1000px',
      data: [this.linkedAppliedAcross, this.isAppliesAcross],
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.linkedAppliedAcross = result[0];
        this.deletedLinkedAppliedAcross = result[1];
        this.saveLinkedAppliesAcross();
      }
    });
  }

  saveLinkedAppliesAcross(): void {
    this.isLoading = true;
    this.regulationService
      .saveAppliesAcrossConnection(this.linkedAppliedAcross)
      .subscribe((result: LinkedAppliesAcrossModel) => {
        if (this.linkedAppliedAcross.linkedAppliesAcrossIds.length > 0 && this.deletedLinkedAppliedAcross.linkedAppliesAcrossIds.length > 0) {
          this.regulationService
            .deleteLinkedAppliesAcrossConnection(
              this.deletedLinkedAppliedAcross
            )
            .subscribe((res: any) => {
              this.deletedLinkedAppliedAcross = new LinkedAppliedAcrossModel();
            });
        }
        this.isLoading = false;
        this.linkedAppliedAcross = new LinkedAppliedAcrossModel();
        this.regulation.appliesAcross =
          result.linkedAppliesAcrossIds.toString();
        if (this.regulation.appliesAcross == '') {
          this.linkedAppliesAcrossIds = [];
        }
        if (this.regulation.appliesAcross) {
          this.getLinkedAppliesAcrossIds();
        }
      });
  }

  getLinkedAppliesAcrossIds(): void {
    this.regulationService
      .getAppliesAccrossLinkedIds(this.regulation.appliesAcross)
      .subscribe((result: LinkedAppliesAcrossIdModel[]) => {
        this.linkedAppliesAcrossIds = result;
      });
  }

  saveComment() {
    this.ownerCommentDetails = new OwnerCommentModel();
    this.ownerCommentDetails.fullName = this.user.fullName;
    this.ownerCommentDetails.id = this.regulation.id;
    this.ownerCommentDetails.ownerComment = this.ownerComment;
    this.regulationService
      .addUpdateCommentTimeStamp(this.ownerCommentDetails)
      .subscribe((res: any) => {
        this.regulationService
          .getAllComments(this.regulation.id)
          .subscribe((res: any) => {
            if (res != null) {
              this.ownerCommentInJsonObject = JSON.parse(res.data);
              this.ownerCommentInArray = Object.entries(
                this.ownerCommentInJsonObject
              );
              this.ownerCommentInArray.reverse();
            }
          });
      });
    this.ownerComment = '';
    this.isComment = false;
  }

  deleteComment(keyValue: string) {
    this.alertDialogModel.HeadingText = 'Delete Comment';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Delete Comment') {
        this.regulationService
          .deleteCommentByKeyAndId(keyValue, this.regulation.id)
          .subscribe((res: any) => {
            if (res.data != null && res.data.length > 0) {
              this.ownerCommentInJsonObject = JSON.parse(res.data);
              this.ownerCommentInArray = Object.entries(
                this.ownerCommentInJsonObject
              );
              this.ownerCommentInArray.reverse();
              this.ownerComment = '';
            }
          });
      }
    });
  }
  //new code for add attachments
  uploadAttachment(id: number): void {
    const fileInput = document.getElementById(
      'uploadAttachment_' + id
    ) as HTMLElement;
    fileInput.click();
  }

  handleFileInput(files: FileList, tableId: number, row: number): void {
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], tableId, row);
    }
  }

  uploadFileToActivity(fileToUpload: any, tableId: number, row: number): void {
    this.isAttachmentLoader = true;
    this.gdprService
      .UploadRulebookControlDocumentAttachmentFile(
        fileToUpload,
        this.currentId,
        tableId
      )
      .subscribe(
        (data: any) => {
          this.fetchAllControlDocumentAttachment();
        },
        (err: HttpErrorResponse) => {
          this.isAttachmentLoader = false;
          this.warningAlert('File not uploaded, please check your file');
          setTimeout(() => { }, 1000);
        }
      );
  }

  openUploadDeleteModel(id: number, tableId: number, row: number): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      width: '450px',
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        this.removeAttachmentDocuments(id, tableId, row);
      }
    });
  }

  removeAttachmentDocuments(id: number, tableId: number, row: number): void {
    this.isAttachmentLoader = true;
    this.gdprService
      .DeleteRulebookControlDocumentAttachmentFile(id)
      .subscribe((data: any) => {
        this.isAttachmentLoader = false;
        this.fetchAllControlDocumentAttachment();
        if (data.result) {
          this.successAlert('File deleted successfully');
        }
      });
  }

  downloadDocument(id: number, fileName: string, extension: string): void {
    this.isAttachmentLoader = true;
    this.gdprService.downloadRulebookControlDocument(id).subscribe(
      (data: any) => {
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
        this.isAttachmentLoader = false;
      },
      (err: HttpErrorResponse) => {
        this.isAttachmentLoader = false;
        console.error(JSON.stringify(err.message));
      }
    );
  }
  fetchAllControlDocumentAttachment(): void {
    this.isAttachmentLoader = true;
    if (this.isVersioned) {
      // this.regulation
      this.gdprService
        .GetRulebookAllControlDocumentAttachment(this.regulation.id)
        .subscribe((result: Array<ControlDocument>) => {
          this.attachmentDocument = result;
          this.isAttachmentLoader = false;
        });
    }
    else {
      this.gdprService
        .GetRulebookAllControlDocumentAttachment(this.currentId)
        .subscribe((result: Array<ControlDocument>) => {
          this.attachmentDocument = result;
          this.isAttachmentLoader = false;
        });
    }
  }
  getFilteredAttachments(id: number) {
    return this.attachmentDocument.filter((item) => item.tableId == id);
  }

  //end new code for addattachments

  //New Code for Update Owner Comment, Open another View after clicking any item of Applies across and
  //setting height of Angular Editor at Interpretation.
  //Start
  updateComment(commentDetails: any) {
    if (
      this.currentUserRole === 'Compliance Enterprise' ||
      this.isOwnerPresent
    ) {
      this.isUpdateComment = true;
      this.isComment = true;
      const regex = /<\/p>([\s\S]*)/;
      if (commentDetails.length > 0) {
        const match = regex.exec(commentDetails[1]);
        let extractedText = '';
        if (match && match.length > 1) {
          extractedText = match[1].trim();
        }
        this.ownerComment = extractedText;
        this.ownerCommentKey = commentDetails[0];
      }
    }
  }
  openView(id: number, detailType: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: { id: id, detailType: detailType, ruleArr: null, filterType: "All", isInnerModel: true },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.sessionService.isLibraryTabActive = false;
    });
  }
  updateUserComment() {
    this.ownerCommentDetails = new OwnerCommentModel();
    this.ownerCommentDetails.fullName = this.user.fullName;
    this.ownerCommentDetails.id = this.regulation.id;
    if (this.ownerComment.length > 0) {
      this.ownerCommentDetails.ownerComment = this.ownerComment;
      this.regulationService
        .updateComment(this.ownerCommentDetails, this.ownerCommentKey)
        .subscribe((res: any) => {
          if (res.result) {
            this.ownerCommentInJsonObject = JSON.parse(res.result);
            this.ownerCommentInArray = Object.entries(
              this.ownerCommentInJsonObject
            );
            this.ownerCommentInArray.reverse();
          }
        });
      this.isUpdateComment = false;
      this.ownerComment = '';
      this.ownerCommentKey = '';
      this.isComment = false;
    }
  }
  cancelUpdateComment() {
    this.ownerComment = '';
    this.ownerCommentKey = '';
    this.isUpdateComment = false;
    this.isComment = false;
  }
  showSpiderLinks(description: string, spLinks: string): string {
    if (description) {
      const descArr = description.split('\n');
      const strArr = new Array<string>();
      descArr.forEach(item => {
        if (item) {
          item = item.replace(/<a/g, '<a target="_blank" ');
          strArr.push('<p>' + item + '</p>');
        }
      });
      description = strArr.join(' ');
    }
    return description;
  }
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "250px",
    minHeight: "5rem",
    placeholder: "Enter text here...",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    toolbarHiddenButtons: [[""]],
    sanitize: false,
    customClasses: [
      {
        name: "quote",
        class: "quote"
      },
      {
        name: "redText",
        class: "redText"
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1"
      }
    ]
  };
  isShowtabs() {
    this.isSummaryShow = true;
    this.isActionShow = true;
    this.isAdditionalShow = true;
    this.isConnectionShow = true;
    this.isOrganizationShow = true;
  }
  hideShowtabs() {
    this.isSummaryShow = false;
    this.isActionShow = false;
    this.isAdditionalShow = false;
    this.isConnectionShow = false;
    this.isOrganizationShow = false;
  }
  expandConnectionPanel() {
    this.isChartExpanded = !this.isChartExpanded;
    if (!this.isChartExpanded) {
      this.isShowtabs();
    }
    else {
      this.hideShowtabs();
      this.isConnectionShow = true;
    }
  }
  //End
  //For Version History (21-06-2013)
  //Start
  openVersionDialog(): void {
    const filterDataModel = new RuleVersionFilterViewModel();
    filterDataModel.regulation = this.regulation;
    filterDataModel.versionId = this.regulation.id;
    filterDataModel.filterType = 'version';
    const dialogRef = this.dialog.open(RulebookVersionDialogComponent, {
      data: filterDataModel,
      width: '650px',
    });

    dialogRef.afterClosed().subscribe(() => { });
  }
  sortArray(itemArray: string[]): string[] {
    let sortArray = MasterHelper.sortArray(itemArray, 'asc');
    return MasterHelper.getDistinctValues(sortArray);
  }
  checkSibling(id: number, type: string): boolean {
    const index = this.rulebookIdList.findIndex((a) => a === this.currentRulebookId);
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.rulebookIdList[index + 1] ? true : false;
      } else {
        return this.rulebookIdList[index - 1] >= 0 ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.rulebookIdList.findIndex(
      (a) => a === this.currentRulebookId
    );
    if (type === 'Next') {
      this.currentRulebookId = this.rulebookIdList[index + 1];
    } else {
      this.currentRulebookId = this.rulebookIdList[index - 1];
    }
    this.getRulebook(this.currentRulebookId);
  }
  //End
  // rulebookDetail
  getRulebook(regulationId: number): void {
    this.isLoadingRegDetails = true;
    if (this.isVersioned == true) {
      this.regulationService.getVersionRulebookByIdForDetail(regulationId).subscribe(
        (data: VersionRegulationModel) => {
          this.linkedRules = [];
          this.linkedPolicies = [];
          this.isLoadingRegDetails = false;
          if (data) {
            this.regulation = data.versionData;
            this.versionNo = this.regulation.userVersion;
            this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
            this.regulationService.isSelfAssessed(this.regulation.id, this.divisionId).subscribe((res: any) => {
              this.selfAssessConfirmation = res.result;
              this.isSelfAssess = this.selfAssessConfirmation.isSelfAssessed;
              this.selfAssessedId = this.selfAssessConfirmation.selfId;
            })
            if (
              this.regulation.owner != null &&
              this.regulation.owner.length > 0
            ) {
              this.ownerDD = this.regulation.owner
                ? this.regulation.owner.split(',')
                : this.ownerDD;
              this.ownerExternalIdList = this.ownerDD
                .map(
                  (name) =>
                    this.searchedOwner.find((item) => item.name === name)
                      ?.externalUserId
                )
                .filter((userId) => userId !== undefined) as string[];
              this.ownerIsUser();
            }
            if (
              this.regulation.interpretation != null &&
              this.regulation.interpretation.length > 0
            ) {
              this.ownerCommentInJsonObject = JSON.parse(
                this.regulation.interpretation
              );
              this.ownerCommentInArray = Object.entries(
                this.ownerCommentInJsonObject
              );
              this.ownerCommentInArray.reverse();
            }
            if (
              this.regulation.appliesAcross != null &&
              this.regulation.appliesAcross.length > 0
            ) {
              let linkedAppliesAcross = this.regulation.appliesAcross;
              this.regulationService
                .getAppliesAccrossLinkedIds(linkedAppliesAcross)
                .subscribe((result: LinkedAppliesAcrossIdModel[]) => {
                  this.linkedAppliesAcrossIds = result;
                });
            }
            if (
              this.regulation.connections != null &&
              this.regulation.connections.length > 0
            ) {
              let linkedIds = this.regulation.connections;
              this.regulationService
                .getLinkedConnectionIds(linkedIds)
                .subscribe((result: LinkedConnectionIdModel[]) => {
                  this.linkedConnectionIds = result;
                });
            }
            this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.rulebookUrl + this.regulation.id
            );
            this.rulebookRuleTopic = this.regulation.ruleTopic
              ? this.regulation.ruleTopic
              : '' + ' ' + this.regulation.pubType
                ? this.regulation.pubType
                : '';
            this.ruleTopicsForToolTip = this.rulebookRuleTopic
              ? this.rulebookRuleTopic.toString().split(',').join('<br/>')
              : '';
            this.regulation.date = MasterHelper.formatDate(
              this.regulation.date,
              'DD-MMM-YYYY'
            ).toString();
            const linkedRuleSplit = this.regulation.linkedRules
              ? this.regulation.linkedRules.toString().split('||')
              : '';
            if (linkedRuleSplit) {
              for (const rule of linkedRuleSplit) {
                const linkedRulePropSplit = rule.split('|');
                const linkedRule = new LinkedRule();
                linkedRule.Country = linkedRulePropSplit[0]
                  ? linkedRulePropSplit[0].trim()
                  : '';
                linkedRule.Regulator = linkedRulePropSplit[1]
                  ? linkedRulePropSplit[1].trim()
                  : '';
                linkedRule.Title = linkedRulePropSplit[2]
                  ? linkedRulePropSplit[2].trim()
                  : '';
                this.linkedRules.push(linkedRule);
              }
            }
            this.sortLinkedRules('Title');

            if (
              this.regulation.previousVersions &&
              this.regulation.previousVersions.length
            ) {
              this.regulation.previousVersions.forEach((a) => {
                a.date = MasterHelper.formatDate(
                  a.date,
                  'DD-MMM-YYYY'
                ).toString();
              });
            }

            const policies = this.regulation.linkedPolicies
              ? this.regulation.linkedPolicies.split('|')
              : '';
            for (const lPolicy of policies) {
              // tslint:disable-next-line:max-line-length
              const policy = new LinkedPolicy(
                1234,
                lPolicy.trim(),
                'Policy',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(policy);
            }

            const risks = this.regulation.linkedRisks
              ? this.regulation.linkedRisks.split('|')
              : '';
            for (const lRisk of risks) {
              // tslint:disable-next-line:max-line-length
              const risk = new LinkedPolicy(
                1234,
                lRisk.trim(),
                'Risk',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(risk);
            }

            const processes = this.regulation.linkedProcesses
              ? this.regulation.linkedProcesses.split('|')
              : '';
            for (const lProcess of processes) {
              // tslint:disable-next-line:max-line-length
              const process = new LinkedPolicy(
                1234,
                lProcess.trim(),
                'Process',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(process);
            }
            this.sortLinkedPolicies('Name');
            //for new designs of linked controls data
            if (data.versionData.linkedControls != null) {
              this.linkedControlList = JSON.parse(data.versionData.linkedControls);
            }
            this.fetchAllControlDocumentAttachment();
          }
        },
        (error: HttpErrorResponse) => {
          Logger.log(this.constructor.name, error.error);
        }
      );
    }
    else {
      this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
      this.gdprService.getRulebookById(regulationId).subscribe(
        (data: RegulationModel) => {
          this.ownerDD = [];
          this.linkedRules = [];
          this.linkedPolicies = [];
          this.linkedAppliesAcrossIds = [];
          this.isLoadingRegDetails = false;
          if (data) {
            this.regulation = data;
            if (this.templateNo == 2) {
              this.gdprService.getSelfAssessmentDetailsT2InRulebook(this.regulation.id).subscribe((res => {
                this.selfAssessmentNew = res;
                this.isEditorShow = true;
                if (this.selfAssessmentNew?.lastApproved != null && this.selfAssessmentNew.assessmentStatus == "Approved") {
                  this.capturedSelfId = this.selfAssessmentNew.id;
                  this.formattedApproveDate = this.selfAssessmentNew.lastApproved ? this.datePipe.transform(this.selfAssessmentNew.lastApproved, 'dd-MMM-yyyy') : '';
                  this.formattedInterDate = this.selfAssessmentNew.interpretationLastEdited ? this.datePipe.transform(this.selfAssessmentNew.interpretationLastEdited, 'dd-MMM-yyyy') : '';
                  this.formattedJudgeDate = this.selfAssessmentNew.judgementLastEdited ? this.datePipe.transform(this.selfAssessmentNew.judgementLastEdited, 'dd-MMM-yyyy') : '';
                  this.formattedGapDate = this.selfAssessmentNew.gapsLastEdited ? this.datePipe.transform(this.selfAssessmentNew.gapsLastEdited, 'dd-MMM-yyyy') : '';
                  const interpretationObject = this.selfAssessmentNew.interpretationDetails ? JSON.parse(this.selfAssessmentNew.interpretationDetails) : '';
                  this.selfAssessmentNew.interpretationDetails = interpretationObject?.data;
                  const judgementObject = this.selfAssessmentNew.judgementDetails ? JSON.parse(this.selfAssessmentNew.judgementDetails) : '';
                  this.selfAssessmentNew.judgementDetails = judgementObject?.data;
                  const gapObject = this.selfAssessmentNew.gapDetail ? JSON.parse(this.selfAssessmentNew.gapDetail) : '';
                  this.selfAssessmentNew.gapDetail = gapObject?.data;
                }
                this.gdprService.getSelfAssessmentStatusDetailsT2InRulebook(this.regulation.id).subscribe(((res: any) => {
                  this.selfAssessmentApprovalList = res;
                }));
              }));
            }
            if (this.templateNo == 3) {
              this.gdprService.getSelfAssessmenT3StatusDetailsInRulebook(this.regulation.id).subscribe(((res: any) => {
                this.selfAssessmentApprovalList = res;
              }));
            }
            this.ruleBookViewCloseData.Id = this.currentId;
            this.ruleBookViewCloseData.IsApplicable = this.regulation.applicable;
            this.ruleBookViewCloseData.IsOperative = this.regulation.operative;
            this.ruleBookViewCloseData.IsRead = this.regulation.isRead;
            this.regulationService.isSelfAssessed(this.regulation.id, this.divisionId).subscribe((res: any) => {
              // this.isSelfAssess = res.result;
              this.selfAssessConfirmation = res.result;
              this.isSelfAssess = this.selfAssessConfirmation.isSelfAssessed;
              this.selfAssessedId = this.selfAssessConfirmation.selfId;
            })
            if (
              this.regulation.owner != null &&
              this.regulation.owner.length > 0
            ) {
              this.ownerDD = this.regulation.owner
                ? this.regulation.owner.split(',')
                : [];
              this.ownerExternalIdList = this.ownerDD
                .map(
                  (name) =>
                    this.searchedOwner.find((item) => item.name === name)
                      ?.externalUserId
                )
                .filter((userId) => userId !== undefined) as string[];
              this.ownerIsUser();
            }
            if (
              this.regulation.interpretation != null &&
              this.regulation.interpretation.length > 0
            ) {
              this.ownerCommentInJsonObject = JSON.parse(
                this.regulation.interpretation
              );
              this.ownerCommentInArray = Object.entries(
                this.ownerCommentInJsonObject
              );
              this.ownerCommentInArray.reverse();
            }
            if (
              this.regulation.appliesAcross != null &&
              this.regulation.appliesAcross.length > 0
            ) {
              let linkedAppliesAcross = this.regulation.appliesAcross;
              this.regulationService
                .getAppliesAccrossLinkedIds(linkedAppliesAcross)
                .subscribe((result: LinkedAppliesAcrossIdModel[]) => {
                  this.linkedAppliesAcrossIds = result;
                });
            }
            if (
              this.regulation.connections != null &&
              this.regulation.connections.length > 0
            ) {
              let linkedIds = this.regulation.connections;
              this.regulationService
                .getLinkedConnectionIds(linkedIds)
                .subscribe((result: LinkedConnectionIdModel[]) => {
                  this.linkedConnectionIds = result;
                });
            }
            this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.rulebookUrl + this.regulation.id
            );
            this.rulebookRuleTopic = this.regulation.ruleTopic
              ? this.regulation.ruleTopic
              : '' + ' ' + this.regulation.pubType
                ? this.regulation.pubType
                : '';
            this.ruleTopicsForToolTip = this.rulebookRuleTopic
              ? this.rulebookRuleTopic.toString().split(',').join('<br/>')
              : '';
            this.regulation.date = MasterHelper.formatDate(
              this.regulation.date,
              'DD-MMM-YYYY'
            ).toString();
            const linkedRuleSplit = this.regulation.linkedRules
              ? this.regulation.linkedRules.toString().split('||')
              : '';
            if (linkedRuleSplit) {
              for (const rule of linkedRuleSplit) {
                const linkedRulePropSplit = rule.split('|');
                const linkedRule = new LinkedRule();
                linkedRule.Country = linkedRulePropSplit[0]
                  ? linkedRulePropSplit[0].trim()
                  : '';
                linkedRule.Regulator = linkedRulePropSplit[1]
                  ? linkedRulePropSplit[1].trim()
                  : '';
                linkedRule.Title = linkedRulePropSplit[2]
                  ? linkedRulePropSplit[2].trim()
                  : '';
                this.linkedRules.push(linkedRule);
              }
            }
            this.sortLinkedRules('Title');

            if (
              this.regulation.previousVersions &&
              this.regulation.previousVersions.length
            ) {
              this.regulation.previousVersions.forEach((a) => {
                a.date = MasterHelper.formatDate(
                  a.date,
                  'DD-MMM-YYYY'
                ).toString();
              });
            }

            const policies = this.regulation.linkedPolicies
              ? this.regulation.linkedPolicies.split('|')
              : '';
            for (const lPolicy of policies) {
              // tslint:disable-next-line:max-line-length
              const policy = new LinkedPolicy(
                1234,
                lPolicy.trim(),
                'Policy',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(policy);
            }

            const risks = this.regulation.linkedRisks
              ? this.regulation.linkedRisks.split('|')
              : '';
            for (const lRisk of risks) {
              // tslint:disable-next-line:max-line-length
              const risk = new LinkedPolicy(
                1234,
                lRisk.trim(),
                'Risk',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(risk);
            }

            const processes = this.regulation.linkedProcesses
              ? this.regulation.linkedProcesses.split('|')
              : '';
            for (const lProcess of processes) {
              // tslint:disable-next-line:max-line-length
              const process = new LinkedPolicy(
                1234,
                lProcess.trim(),
                'Process',
                'xSmith',
                'Asset Management Wealth Management',
                'COO',
                'UK Germany France'
              );
              this.linkedPolicies.push(process);
            }
            this.sortLinkedPolicies('Name');
            //for new designs of linked controls data
            if (data.linkedControls != null) {
              this.linkedControlList = JSON.parse(data.linkedControls);
            }
            this.fetchAllControlDocumentAttachment();
          }
        },
        (error: HttpErrorResponse) => {
          Logger.log(this.constructor.name, error.error);
        }
      );
    }
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  goToSelf() {
    // window.location.href = '/self-assessment/details/self/'+this.selfAssessedId;
    this.openAssessmentPopup(this.selfAssessedId);
  }
  openApprovedSelfAssessment(id: number) {
    this.openAssessmentPopup(id);
  }
  openAssessmentPopup(id: number): void {
    const assessModel = new OpenAssessModel();
    assessModel.id = id;
    assessModel.templateNo = this.templateNo;
    const dialogRef = this.dialog.open(SelfAssessmentModalDialogComponent, {
      width: '1800px',
      height: '870px',
      data: assessModel
    });
    dialogRef.afterClosed().subscribe(() => {
    });
    // this.gdprService.getSelfAssessmentTemplate(this.divisionId).subscribe((res: number) => {

    // });
  }
  changeSelfAssessment(selfAssessmentId: number) {
    let myData = this.selfAssessmentApprovalList?.find(a => a.id == selfAssessmentId);
    if (myData != null) {
      this.selfAssessmentNew = myData;
      if (this.selfAssessmentNew?.lastApproved != null && this.selfAssessmentNew.assessmentStatus == "Approved") {
        this.capturedSelfId = this.selfAssessmentNew.id;
        this.formattedApproveDate = this.selfAssessmentNew.lastApproved ? this.datePipe.transform(this.selfAssessmentNew.lastApproved, 'dd-MMM-yyyy') : '';
        this.formattedInterDate = this.selfAssessmentNew.interpretationLastEdited ? this.datePipe.transform(this.selfAssessmentNew.interpretationLastEdited, 'dd-MMM-yyyy') : '';
        this.formattedJudgeDate = this.selfAssessmentNew.judgementLastEdited ? this.datePipe.transform(this.selfAssessmentNew.judgementLastEdited, 'dd-MMM-yyyy') : '';
        this.formattedGapDate = this.selfAssessmentNew.gapsLastEdited ? this.datePipe.transform(this.selfAssessmentNew.gapsLastEdited, 'dd-MMM-yyyy') : '';
        const interpretationObject = this.selfAssessmentNew.interpretationDetails ? JSON.parse(this.selfAssessmentNew.interpretationDetails) : '';
        this.selfAssessmentNew.interpretationDetails = interpretationObject?.data;
        const judgementObject = this.selfAssessmentNew.judgementDetails ? JSON.parse(this.selfAssessmentNew.judgementDetails) : '';
        this.selfAssessmentNew.judgementDetails = judgementObject?.data;
        const gapObject = this.selfAssessmentNew.gapDetail ? JSON.parse(this.selfAssessmentNew.gapDetail) : '';
        this.selfAssessmentNew.gapDetail = gapObject?.data;
      }
      this.ref.detectChanges();
    }
  }
  editButtonClick() {
    let splitDesc = this.regulation.description.split('\n');
    let newArray: string[] = []; // Fix: Initialize newArray as an empty array of type string[]
    if (splitDesc.length > 0) {
      splitDesc.forEach(element => {
        element = '<p>' + element + '</p>';
        newArray.push(element);
      });
      this.descriptionInEditor = newArray.join(' ');
    }
    else {
      this.descriptionInEditor = this.regulation.description;
    }

    this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
  }
  saveDescriptionButtonClick() {
    let descriptionModel = new updateRulebookModel();
    descriptionModel.id = this.currentId;
    descriptionModel.rulebookDescription = this.descriptionInEditor;
    this.gdprService.updateRulebookDescription(descriptionModel).subscribe(
      (data: any) => {
        if (data.message == "Successfull") {
          this.regulation.description = this.descriptionInEditor;
          this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
        }
      })
  }
  cancelDescriptionButtonClick() {
    this.descriptionInEditor = this.regulation.description;
    this.isShowDescriptionEditor = !this.isShowDescriptionEditor;
  }
  joseToken: any = [];
  streamlitUrl!: string;
  isAssessmentLoader: boolean = false;
  translateDescription() {
    this.isAssessmentLoader = true;
    const containsSubstring = this.regulation.description.includes("Non-Legal Translation of the Regulatory Text");
    if (!containsSubstring) {
      let ob = new translateOthersToEnglishInputModel();
      ob.textToTranslate = this.regulation.description;
      ob.tableName = "Rulebooks_v3";
      ob.updatesId = this.regulation.id;
      this.regulationService.sendTranslatePostRequest(this.joseToken.message, ob).subscribe((response: any) => {
        if (response && response?.message) {
          if (response?.message == "Text already in english") {
            this.toastModel.Title = 'Warning';
            this.toastModel.Type = 'warning';
            this.toastModel.Message = 'Text already in english';
          }
          else {
            this.regulation.description = response.message;
            this.toastModel.Title = 'Success';
            this.toastModel.Type = 'success';
            this.toastModel.Message = 'Language translation successful';
          }

          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 3500);
        }
        else {
          this.toastModel.Title = 'Warning';
          this.toastModel.Type = 'warning';
          this.toastModel.Message = 'Language translation failed due to character length limit';
          this.isToastShow = true;
          setTimeout(() => {
            this.isToastShow = false;
          }, 3500);
        }
        this.isAssessmentLoader = false;
      });
    }
    else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
      this.toastModel.Message = 'The Description is already translated';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 3500);
      this.isAssessmentLoader = false;
    }
  }

  sanitizeUrl(url: string): SafeUrl {
    const secureUrl = url.replace('http://', 'https://');
    return this.sanitizer.bypassSecurityTrustUrl(secureUrl);
  }

  openInNewTab(item: string) {
    item = item.replace(/<a/g, '<a target="_blank" ');
    return item;
  }
}
